import { render, staticRenderFns } from "./estate-details-header.vue?vue&type=template&id=8bc7ff88&"
import script from "./estate-details-header.vue?vue&type=script&lang=js&"
export * from "./estate-details-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports